import axios from 'axios';
import { url } from 'utils/urls';

const withCredentials = true;
const headers = {
    "Content-Type": "application/json",
    'Accept': 'application/json',
};

export const createEmbed = (siteUUID, data) => axios.post(`${url.ppa.sites}/${siteUUID}/embeds/content`, JSON.stringify(data), { headers, withCredentials });

export const updateEmbed = (siteUUID, embedUUID, data) => axios.put(`${url.ppa.sites}/${siteUUID}/embeds/${embedUUID}/content`, data, { headers, withCredentials });

export const asyncGetEmbedNames = (accountUUID) => axios.get(`${url.ppa.accounts}/${accountUUID}/embeds`, { headers, withCredentials });

export const deleteEmbedByUUID = embedUUID => axios.delete(`${url.ppa.embeds}/${embedUUID}`, { withCredentials });

export const getClientEmbedsData = (accountUUID, data) => axios.post(`${url.ppa.accounts}/${accountUUID}/embeds/content`, data, { withCredentials });

export const archiveEmbed = (embedUUID) => axios.put(`${url.ppa.embeds}/${embedUUID}/archive`, {}, { withCredentials });

export const unarchiveEmbed = (embedUUID) => axios.put(`${url.ppa.embeds}/${embedUUID}/unarchive`, {}, { withCredentials });

export const getEmbedByUUID = embedUUID => axios.get(`${url.ppa.embeds}/${embedUUID}/sites/content`, { withCredentials });

export const getEmbedEmailData = (embedUUID, page, startDate, endDate, isExport) => axios.get(`${url.ppa.metrics.url}/engageduserdata?startDate=${startDate}&endDate=${endDate}&embedUUID=${embedUUID}&currentPage=${page}&isExport=${isExport}`, { withCredentials });



export const requestEmbedCode = (siteUUID, embedUUID) => axios.get(`${url.ppa.embeds}/${embedUUID}/embedcode/?siteUUID=${siteUUID}&version=VERSION_4_0`, { withCredentials });


//Retrieve image resources from respective APIs:
//Cancellation tokens for image retrieval functions
const shutterStockCancelToken = axios.CancelToken;
const unsplashCancelToken = axios.CancelToken;
const giphyCancelToken = axios.CancelToken;
const userImagesCancelToken = axios.CancelToken;

export let shutterStockCancel;
export let unsplashCancel;
export let giphyCancel;
export let userImagesCancel;


//ShutterStock:
export const queryShutterStock = (query, page) => axios.get(`${url.shutterStock.search}&query=${query}&page=${page}`, {
    headers: url.shutterStock.headers,
    cancelToken: new shutterStockCancelToken(function executor(c){shutterStockCancel=c})
});


//Unsplash:
export const queryUnsplash = (query, page) => axios.get(`${url.unsplash.search}&query=${query}&page=${page}`, {
    headers: url.unsplash.headers,
    cancelToken: new unsplashCancelToken(function executor(c){unsplashCancel=c})
});


//Giphy:
export const queryGiphy = (query, page) => axios.get(`${url.giphy.search}${query}&offset=${(page-1)*40}`, {
    cancelToken: new giphyCancelToken(function executor(c){giphyCancel=c})
});


//User Images:
export const queryUserImages = (UUID) => axios.get(`${url.ppa.accounts}/${UUID}/images`, {
    withCredentials: true,
    cancelToken: new userImagesCancelToken(function executor(c){userImagesCancel=c})
});


//Default Query
export const defaultQuery = 'nyc';

//Retrieve page resources such as title, description and image:
//Retrieve Page Resource:
export const retrievePageResource = (pageUrl) => axios.get(`${url.embed.utils}/getopengraphparams?url=${pageUrl}`);